import * as React from 'react';
import { Validation } from 'ui';
import { CheckboxListItem } from 'ui/checkbox-list/checkbox-list-item';
import { MultiKeyValueComponent, ComplexValue } from 'ui/common/types';

/**
 * Creates CheckboxList component.
 *
 */

export class CheckboxList extends React.PureComponent<MultiKeyValueComponent<number>, any> {
  private onChange = (option: ComplexValue<number>, isSelected: boolean) => {
    const valueItems = this.props.valueItems || [];
    this.props.onChange(isSelected ? valueItems.concat(option) :
      this.props.valueItems.filter(item => item.value !== option.value));
  };

  private renderItem = (index: number, item: ComplexValue<number>, isSelected: boolean) => {
    return <li key={index}>
      <CheckboxListItem
        name={this.props.componentId}
        onChange={this.onChange}
        option={item}
        isSelected={isSelected} />
    </li>;
  };

  public renderOptions = () => {
    return !!this.props.options && this.props.options.length > 0 &&
      this.props.options.map((item, index) => {
        const isSelected = !!this.props.valueItems && this.props.valueItems.some(option => option.value === item.value);
        return this.renderItem(index, item, isSelected);
      });
  };

  public render() {
    return (<>
      <ul id={this.props.componentId} className={this.props.className}>
        {this.renderOptions()}
      </ul>
      {this.props.validation && <Validation {...this.props.validation} />}
      </>
    );
  }
}
